import { t, onLangChange } from '../i18n';

export interface LoadingOverlay {
  dismiss(): void;
}

export function showLoadingOverlay(): LoadingOverlay {
  const el = document.createElement('div');
  el.id = 'loading';
  el.setAttribute('role', 'status');
  el.setAttribute('aria-live', 'polite');
  el.innerHTML = `
    <p class="loading-text"></p>
    <div class="loading-bar" aria-hidden="true"><span></span></div>`;
  const textEl = el.querySelector('.loading-text') as HTMLParagraphElement;

  const applyLang = () => {
    textEl.textContent = t('loading');
  };
  applyLang();
  onLangChange(applyLang);

  document.body.appendChild(el);
  requestAnimationFrame(() => el.classList.add('visible'));

  return {
    dismiss() {
      el.classList.remove('visible');
      const remove = () => el.remove();
      el.addEventListener('transitionend', remove, { once: true });
      setTimeout(remove, 600);
    },
  };
}

export function showErrorPanel(err: unknown): void {
  document.getElementById('loading')?.remove();

  const el = document.createElement('div');
  el.id = 'load-error';
  el.setAttribute('role', 'alert');
  el.innerHTML = `
    <div class="load-error-panel">
      <h1 class="wordmark">MOSER</h1>
      <p class="load-error-message"></p>
      <p class="load-error-detail"></p>
      <button type="button" class="load-error-retry"></button>
    </div>`;

  const messageEl = el.querySelector('.load-error-message') as HTMLParagraphElement;
  const detailEl = el.querySelector('.load-error-detail') as HTMLParagraphElement;
  const retryBtn = el.querySelector('.load-error-retry') as HTMLButtonElement;

  const applyLang = () => {
    messageEl.textContent = t('loadError');
    retryBtn.textContent = t('loadErrorRetry');
  };
  applyLang();
  onLangChange(applyLang);

  detailEl.textContent = err instanceof Error ? err.message : String(err);
  retryBtn.addEventListener('click', () => location.reload());

  document.body.appendChild(el);
}
